import { combineReducers } from "redux";

export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_LOGOUT_SUCCESS = "AUTH_LOGOUT_SUCCESS";

export const authorize = (email, password) => ({
  type: AUTH_REQUEST,
  payload: { email, password }
});

export const logout = () => ({
  type: AUTH_LOGOUT
});

const initialState = {
  accessToken: localStorage.getItem("token"),
  role: localStorage.getItem("role"),
  userId: "",
  clientId: "",
  refreshToken: "",
  expiresIn: "",
  expiresAt: "",
  tokenType: "",
  error: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTH_SUCCESS: {
      return { ...state, ...payload, error: null };
    }
    case AUTH_FAILURE: {
      return { ...state, error: payload };
    }
    case AUTH_LOGOUT_SUCCESS: {
      return { ...initialState, accessToken: "", role: "user" };
    }
    default:
      return state;
  }
};

export default reducer;
